/*==============================================================================
  
  This is the unminified file. Use this for development. Minify the file for
  production.

  *Includes Bold Product Options JS
  
  Slate A11y Helpers - slate.a11y
  Slate Utility Helpers - slate.utils
  Slate Rich Text Editor - slate.rte
  Theme Sections - theme.Sections
  Slate Currency - slate.Currency
  Slate Image - slate.Image
  Slate Variants - slate.Variants
  Theme Custom Variants - theme.CustomVariants (Used for linked options and no default variants)


  MODULES

  theme.HeaderNav
  theme.HeaderNavTouch
  theme.Slideshow
  theme.Drawers
  theme.Modals
  theme.Collapsibles
  theme.Tabs

  theme.ajaxCartUtilities
  theme.AjaxProduct
  theme.currencySwitcher


  SECTIONS

  theme.Product
  theme.HeaderSection
  theme.DrawerMenuSection
  theme.CartSection
  theme.Collection
  theme.SlideshowSection
  theme.Instagram
  theme.PromoBarSection
  theme.Testimonials
  theme.FeaturedVideoSection


  theme.initEventModals
  theme.ajaxNewsletterForm
  theme.isElementVisible
  theme.loadImageSection


  OTHER

  theme.config = isTouch, mq, bpSmall
  theme.mq
  theme.init = enquire, tab handling, collapsibles, tabs, ajaxNewsletter, initEventModals, AOS



  TEMPLATES

  theme.customerAddresses
  theme.customerLogin
  Shopify Shipping Calculator


  DOC READY
  theme.init
  sections
  slate
  
==============================================================================*/





window.slate = window.slate || {};
window.theme = window.theme || {};





/*==============================================================================
  #SLATE a11y
==============================================================================*/

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }

};










/*==============================================================================
  #SLATE Utility Helpers
==============================================================================*/

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 *
 * #EDIT
 * - Added arrayIncludes and uniq utilities for linked product options
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  },


  /**
   * A utility from Shopify option_selection.js needed for linked product
   * options.
   */
  arrayIncludes: function(e, t) {
    for (var n = 0; n < e.length; n++)
        if (e[n] == t) return !0;
    return !1
  }, 


  /**
   * A utility from Shopify option_selection.js needed for linked product
   * options.
   */
  uniq: function(e) {
      for (var t = [], n = 0; n < e.length; n++) slate.utils.arrayIncludes(t, e[n]) || t.push(e[n]);
      return t
  }
};










/*==============================================================================
  #SLATE Rich Text Editor
==============================================================================*/

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};










/*==============================================================================
  #THEME Sections
==============================================================================*/

/**
 * Sections
 * - Largely based on Slate and Impulse theme with some minor adjustments.
 * - https://help.shopify.com/en/themes/development/sections#understand-the-interaction-between-theme-javascript-and-the-theme-editor
 * - Added support for subsections
 * - Added simpler findInstance and removeInstance functions
 */


theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  // Register event listeners for section events
  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = $.extend({}, theme.Sections.prototype, {

  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  // We are using subSections for dynamic non-homepage section blocks
  _onSectionLoad: function(evt, subSection, subSectionId) {

    // Check if we have a subSection or a Section
    var container = subSection ? subSection : $('[data-section-id]', evt.target)[0];

    // If no subSection or Section exists, stop running
    if (!container) {
      return;
    }

    // Register section
    this._createInstance(container);

    // Store subSection or Section ID as an instance
    var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);

    // #? I don't understand this. Why is it loading subsections, if a
    // subsection doesn't exist?
    if (!subSection) {
      this._loadSubSections();
    }

    // Run JS only in case of the section being selected in the editor
    // before merchant clicks "Add"
    if (instance && typeof instance.onLoad === 'function') {
      instance.onLoad(evt);
    }
  },

  // Look for `data-subsection` attributes and load them
  _loadSubSections: function() {
    $('[data-subsection]').each(function(evt, el) {
      this._onSectionLoad(null, el, $(el).data('section-id'));
    }.bind(this));
  },

  _onSectionUnload: function(evt) {
    var instance = this._removeInstance(evt.detail.sectionId);

    if (instance && typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }
  },

  _onSelect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  // A simpler version of findInstance specific to sections
  _findInstance: function(id) {
    for (var i = 0; i < this.instances.length; i++) {
      if (this.instances[i].id === id) {
        return this.instances[i];
      }
    }
  },

  // A simpler version of removeInstance specific to sections
  _removeInstance: function(id) {
    var i = this.instances.length;
    var instance;

    while(i--) {
      if (this.instances[i].id === id) {
        instance = this.instances[i];
        this.instances.splice(i, 1);
        break;
      }
    }

    return instance;
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;
    var $sections = $('[data-section-type=' + type + ']');

    $sections.each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});










/*==============================================================================
  #SLATE Currency
==============================================================================*/

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();










/*==============================================================================
  #SLATE Image
==============================================================================*/

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 * #EDIT: Added default size of 620x to imageSize function
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   *
   * Added default size of 620x
   */
  function imageSize(src) {
    if (!src) {
      return '620x'; // default based on theme
    }

    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();










/*==============================================================================
  #SLATE Variants
==============================================================================*/

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 *
 * #EDIT: 
 * - Added _updateSKU function
 * - Added _updateVariantButtons function for linked options
 * - Updated _getVariantFromOptions code to be simpler
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');
            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var match = true;
        var options = variant.options

        selectedValues.forEach(function(option) {
          if (match) {
            match = (variant[option.index] === option.value);
          }
        });

        if (match) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this._updateVariantButtons(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },


    /**
     * CUSTOM EVENT. If using buttons for our variants and linked options,
     * trigger change when selecting another button variant
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantButtonChange
     */
    _updateVariantButtons: function(variant) {
      this.$container.trigger({
        type: 'variantButtonChange',
        variant: variant
      });
    },


    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();










/*==============================================================================
  #THEME CustomVariants
  - An edited version of slate.Variants
  - This code works when not wanting to use a default/selected variant
  - This code works with linked option selectors
  - We use in tandem with `sections/product-template-no-selected-variant`
==============================================================================*/

theme.CustomVariants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');
            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var match = true;
        var options = variant.options

        selectedValues.forEach(function(option) {
          if (match) {
            match = (variant[option.index] === option.value);
          }
        });

        if (match) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function(evt) {

      // Stores the target of our variant button click
      var $target = $(evt.currentTarget);

      // Stores our master selector
      var $originalSelectorId = $(this.originalSelectorId);

      // Stores how many product options we have
      var productOptionsLength = this.product.options.length;


      // These variables will change depending on what variant is selected
      var firstOptionSelected = false;
      var secondOptionSelected = false;

      // When using linked options, we don't want the variant to change until
      // a user has selected all options. This variable checks for that.
      var optionChangeWithNoVariant = false;

      // Register what options have been selected
      if (productOptionsLength > 1) {
        if ($target.data('index') == 'option1') {
          firstOptionSelected = true;
        }
        
        if (productOptionsLength === 3) {
          if ($target.data('index') == 'option2') {
            secondOptionSelected = true;
          }
        }
      }

      // Checks if we select a variant
      var variantIsSelected = true;

      if ($originalSelectorId[0].selectedIndex == 0) {
        variantIsSelected = false;
      } else {
        variantIsSelected = true;
      }


      // If we have chosen an option and not selected a variant, we register
      // this
      if (firstOptionSelected || secondOptionSelected) {
        if (!variantIsSelected) {
          optionChangeWithNoVariant = true;
        }
      }

      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant,
        optionChangeWithNoVariant: optionChangeWithNoVariant
      });

      if (!variant) {
        return;
      }

      // If we have an option change but no variant selected, we only update
      // our images and buttons
      // Else, we have selected a variant so we run everything
      if (optionChangeWithNoVariant) {
        this._updateImages(variant);
        this._updateVariantButtons(variant);
        this.currentVariant = variant;
      } else {
        this._updateMasterSelect(variant);
        this._updatePrice(variant);
        this._updateSKU(variant);
        this._updateImages(variant);
        this._updateVariantButtons(variant);
        this.currentVariant = variant;

        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
      }

    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      // if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
      //   console.log('matches so return');
      //   return;
      // }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },


    /**
     * CUSTOM EVENT. If using buttons for our variants and linked options,
     * trigger change when selecting another button variant
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantButtonChange
     */
    _updateVariantButtons: function(variant) {
      this.$container.trigger({
        type: 'variantButtonChange',
        variant: variant
      });
    },


    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();




















/*==============================================================================
  #MODULES
==============================================================================*/

/*==============================================================================
  #HeaderNav
==============================================================================*/

theme.HeaderNav = (function() {
  var selectors = {
    body: 'body',
    header: '.header',
    itemHasDropdown: '.header-nav__item--main--has-dropdown',
    mainLinks: '.header-nav__link--main',
    childLinks: '.header-nav__link--child',
    grandchildLinks: '.header-nav__link--grandchild',

    activeDropdown: '.header-nav__item--main--dropdown-is-open'
  };


  var cache = {};


  var config = {
    activeDropdown: 'header-nav__item--main--dropdown-is-open',
    childLinks: 'header-nav__link--child',
    grandchildLinks: 'header-nav__link--grandchild',
    namespace: '.dropdown',
    transparentHeader: 'header--transparent',
    hasTransparentHeader: false
  }

  function cacheSelectors() {
    cache = {
      $window: $(window),
      $body: $(selectors.body),
      $header: $(selectors.header),
      $itemHasDropdown: $(selectors.itemHasDropdown),
      $mainLinks: $(selectors.mainLinks),
      $childLinks: $(selectors.childLinks),
      $grandchildLinks: $(selectors.grandchildLinks)
    };
  }


  function init() {

    // Make our cached objects available
    cacheSelectors();

    // Initialise ARIA attributes
    cache.$itemHasDropdown.find(selectors.mainLinks).attr({
      'aria-haspopup': 'true',
      'aria-expanded': 'false'
    });

    if (cache.$header.hasClass(config.transparentHeader)) {
      config.hasTransparentHeader = true;
    }



    /**
     * 1. Dropdown click event handler 
     * The event handlers uses `evt.preventDefault()` to stop a link from 
     * firing, and allowing us to open or click a dropdown. This means that 
     * child links in our dropdown are also prevented from firing.
     */
    cache.$itemHasDropdown.on('click.' + config.namespace, toggleDropdown); /* [1] */

    /**
     * 2. Child and Grandchild Dropdown Links click event handler
     * Provides correct link behaviour to our child dropdown links. Our dropdown
     * click event handler prevents default link behaviour which also stops
     * our child dropdown links from firing. We use evt.stopPropagation on our 
     * child dropdown links to ensure they keep correct link behaviour.
     */
    cache.$childLinks.on('click' + config.namespace, function(evt) { /* [2] */
      evt.stopPropagation();
    });

    cache.$grandchildLinks.on('click' + config.namespace, function(evt) { /* [2] */
      evt.stopPropagation();
    });

  };



  /**
   * toggleDropdown function is bound to our dropdown click event handler, so
   * we pass in evt to our function.
   */

  function toggleDropdown(evt) {

    // `this` will refer to the dropdown we have clicked on. We wrap `this` in a
    // jQuery object.
    var $this = $(this);


    /**
     * 1. Prevent default link behaviour. This allows the dropdown to open or close
     * rather than the link click being fired and being sent to another page.
     * 
     * 2. We have a click event handler on our body that closes dropdowns. 
     * We need to stop immediate propagation so the click event doesn't bubble 
     * up to body level and close the dropdown straight after it is revealed,
     * and no other event handlers on the element or parent are fired that
     * interfere.
     */
    evt.preventDefault(); /* [1] */
    evt.stopImmediatePropagation(); /* [2] */

    /**
     * If dropdown is open, we close the dropdown. Else we open it. We pass in
     * `$this` which is our dropdown into our open or close functions.
     */
    if ($this.hasClass(config.activeDropdown)) {
      closeDropdown($this);
    } else {
      openDropdown($this);
    }
  };



  /**
   * Open Dropdown function. We take a parameter which is the active dropdown
   */
  function openDropdown($this) {
    /**
     * If an active dropdown is open, close it before opening another dropdown.
     * We do not use a cached selector such as $activeDropdown because that 
     * does not get updated when the DOM changes.
     */
    if ($(selectors.activeDropdown).length) {
      closeDropdown($(selectors.activeDropdown));
    }

    // Show dropdown by adding class that will display dropdown
    $this.addClass(config.activeDropdown);

    // ARIA set expanded to true
    $this.find(selectors.mainLinks).attr(
      {
        'aria-expanded': 'true'
      }
    );

    /**
     * Attach event handlers to close the dropdown. These event handlers should
     * only fire when a dropdown is open.
     */

    // Close dropdown on click of body
    cache.$body.on('click' + config.namespace, function(evt) {
      closeDropdown($this);
    });

    // Close dropdown on keypress of escape
    cache.$window.on('keyup' + config.namespace, function(evt) { /* [2] */
      if (evt.which === 27) {
        closeDropdown($this);
      }
    });


    /** 
     * 1. Attach focusout event on active dropdown to close when focus moves
     * to another element.
     *
     * 2. A focused element is referred to as `document.activeElement`. We want
     * to make sure that focusing on child dropdown links keeps the dropdown
     * open. The focusout event moves focus to the body for a fraction of a
     * second and then moves to the child element. So, we can use setTimeout to 
     * allow for getting focus on the child element, and stop our event firing
     * until we get there.
     */

    $this.on('focusout' + config.namespace, function(evt) { /* [1] */

      setTimeout(function() { /* [2] */
        if ($(document.activeElement).hasClass(config.childLinks) || $(document.activeElement).hasClass(config.grandchildLinks)) {
        return;
      }
        closeDropdown($this);
      }, 0);

    });

  };



  /**
   * Close Dropdown function. We take a parameter which is the active dropdown
   */
  function closeDropdown($this) {

    // Hide dropdown by removing class in CSS, so dropdown will display:none
    $this.removeClass(config.activeDropdown);

    // ARIA set expanded to false
    $this.find(selectors.mainLinks).attr(
      {
        'aria-expanded': 'false'
      }
    );

    /**
     * Detach event handlers to close dropdown. These event handlers were
     * attached when the dropdown is open, but not needed when closed.
     */
    cache.$body.off('click' + config.namespace);
    cache.$window.off('keyup' + config.namespace);
    // $this.off('focusout' + config.namespace);
  };



  /**
   * Revealing module pattern, we expose a specific part of our module to the
   * global scope.
   */

  return {
    init: init
  };
})(); /* end theme.HeaderNav */










/*==============================================================================
  #HeaderNavTouch
  - Unused
==============================================================================*/

theme.HeaderNavTouch = (function() {
  var selectors = {
    body: 'body',
    itemHasDropdown: '.header-nav__item--main--has-dropdown',
    mainLinks: '.header-nav__link--main',
    childLinks: '.header-nav__link--child',
    grandchildLinks: '.header-nav__link--grandchild',

    activeDropdown: '.header-nav__item--main--dropdown-is-open'
  };

  var cache = {};

  var config = {
    activeDropdown: 'header-nav__item--main--dropdown-is-open',
    childLinks: 'header-nav__link--child',
    grandchildLinks: 'header-nav__link--grandchild',
    namespace: '.dropdown'
  }


  function cacheSelectors() {
    cache = {
      $window: $(window),
      $body: $(selectors.body),
      $itemHasDropdown: $(selectors.itemHasDropdown),
      $mainLinks: $(selectors.mainLinks),
      $childLinks: $(selectors.childLinks),
      $grandchildLinks: $(selectors.childLinks)
    };
  } /*----- END cacheSelectors() -----*/



  function init() {

    // Make our cached objects available
    cacheSelectors();

    // Initialise ARIA attributes on li elements with dropdown
    cache.$itemHasDropdown.attr({
      'aria-haspopup': 'true',
      'aria-expanded': 'false'
    });


    /**
     * TOUCH DEVICE EVENT HANDLER
     * There are difficulties with hover and mouseover states on touch devices.
     * Targeting touch devices is not 100% fool-proof.
     *
     * We need to make sure that the first tap on a touch device will open the
     * dropdown, and the second tap will take a user to their respective link.
     * Useful to be aware that as our `li` element has the event listeners, the
     * `a` link target event will bubble up to the `li` element.
     *
     * 1. If the dropdown is not open, we prevent default link behaviour and
     *    open the dropdown. 
     */
    if (theme.config.isTouch) {

      cache.$itemHasDropdown.on('click touchend' + config.namespace, function(evt) {
        var $el = $(this);

        if (!$el.hasClass(config.activeDropdown)) {
          evt.preventDefault(); /* [1] */
          openDropdown($el); /* [1] */
        }

      })
    };


    /**
     * EVENT HANDLER
     * We use this event handler for non-touch devices. If a user focuses or
     * hovers, we'll open the dropdown.
     * We use the `mouseenter` event as `mouseover` will track every movement
     * which we don't need.
     */

    cache.$itemHasDropdown.on('focusin mouseenter' + config.namespace, function(evt){
      var $el = $(this);
      openDropdown($el);
    })

  }; /*----- END init() -----*/



  /**
   * Open Dropdown function. We take a parameter which is the list element the 
   * user has interacted with.
   */
  function openDropdown($el) {

    /**
     * If an active dropdown is open, close it before opening another dropdown.
     * We do not use a cached selector such as $activeDropdown because that 
     * does not get updated when the DOM changes.
     */
    if ($(selectors.activeDropdown).length) {
      closeDropdown($(selectors.activeDropdown));
    }


    // Show dropdown by adding class that will display dropdown
    $el.addClass(config.activeDropdown);


    // ARIA set expanded to true
    $el.attr(
      {
        'aria-expanded': 'true'
      }
    );


    /**
     * Attach event handlers to close the dropdown. These event handlers should
     * only fire when a dropdown is open.
     */
    $el.on('mouseleave' + config.namespace, function(evt){
      closeDropdown($el);
    });


    /** 
     * 1. Attach focusout event on active dropdown to close when focus moves
     * to another element.
     *
     * 2. A focused element is referred to as `document.activeElement`. We want
     * to make sure that focusing on child dropdown links keeps the dropdown
     * open. The focusout event moves focus to the body for a fraction of a
     * second and then moves to the child element. So, we can use setTimeout to 
     * allow for getting focus on the child element, and stop our event firing
     * until we get there.
     */

    $el.on('focusout' + config.namespace, function(evt) { /* [1] */
      setTimeout(function() { /* [2] */
        if ($(document.activeElement).hasClass(config.childLinks) || $(document.activeElement).hasClass(config.grandchildLinks)) {
          return;
        }
        closeDropdown($el);
      }, 0);
    });

  }; /*----- END openDropdown() -----*/



  /**
   * Close Dropdown function. We take a parameter which is the list element the 
   * user has interacted with.
   */

  function closeDropdown($el) {

    // Hide dropdown by removing CSS class
    $el.removeClass(config.activeDropdown);

    // ARIA set expanded to false
    $el.attr(
      {
        'aria-expanded': 'false'
      }
    );

    /**
     * Detach event handlers to close dropdown. These event handlers were
     * attached when the dropdown is open, but not needed when closed.
     */
    $el.on('mouseleave' + config.namespace, function(evt){
      closeDropdown($el);
    });
  };

  /**
   * Revealing module pattern, we expose a specific part of our module to the
   * global scope.
   */

  return {
    init: init
  };
})(); /* end theme.HeaderNavTouch */










/*==============================================================================
  #Slidesow

    Slideshow module that can be used across the site. When requiring a new
    slideshow (product page, homepage section, etc) we can call this function
    and pass in the element we want as our slideshow. Based loosely on Impulse
    and Debut Shopify themes.
   
    DEPENDENCIES:
    - Slick Slider (stored in our vendor.js)
    - jQuery
==============================================================================*/

theme.Slideshow = (function() {

  // By default this is null, until we pass in a slideshow
  this.$slideshow = null;

  // Store our selectors
  var selectors = {
    slideshowWrapper: '.slideshow-wrapper',
    slideshow: '.slideshow',
    next: '.is-next',
    init: '.is-init',
    animateOut: '.animate-out',
    allSlides: '.slick-slide',
    currentSlide: '.slick-current',
    pauseButton: '.slideshow__pause',
    isPaused: '.is-paused'
  };


  // Store our classes / config
  var classes = {
    slideshowWrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    next: 'is-next',
    init: 'is-init',
    animateOut: 'animate-out',
    allSlides: 'slick-slide',
    currentSlide: 'slick-current',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused'
  }


  // We pass in the slideshow (el) and it's settings (args)
  function slideshow(el, args) {

    // Store our variables as jQuery
    this.$slideshow = $(el);
    this.$wrapper = this.$slideshow.closest(selectors.slideshowWrapper);

    // this.$pause = this.$wrapper.find(selectors.pauseButton); 


    /**
     * Settings object for the slideshow. Slick options here:
     * https://github.com/kenwheeler/slick#settings
     */
    this.settings = {
      accessibility: true,
      arrows: args.arrows ? true : false,
      dots: args.dots ? true : false,
      autoplay: args.autoplay ? true : false,
      autoplaySpeed: args.autoplaySpeed ? args.autoplaySpeed : false,
      rows: 0,
      prevArrow: args.prevArrow ? args.prevArrow : false,
      nextArrow: args.nextArrow ? args.nextArrow : false
    };

    this.mobileSettings = {
      accessibility: true,
      arrows: args.arrows ? true : false,
      dots: args.dots ? true : false,
      autoplay: args.autoplay ? true : false,
      autoplaySpeed: args.autoplaySpeed ? args.autoplaySpeed : false,
      rows: 0,
      prevArrow: args.prevArrow ? args.prevArrow : false,
      nextArrow: args.nextArrow ? args.nextArrow : false,
      slidesToShow: 2
    }


    /**
     * Event Handlers
     * https://github.com/kenwheeler/slick#events
     */
    this.$slideshow.off('beforeChange');
    this.$slideshow.off('afterSlideChange');

    // Init must be called before initializing the slider
    this.$slideshow.on('init', this.init.bind(this));
    this.$slideshow.on('beforeChange', this.beforeSlideChange.bind(this));
    this.$slideshow.on('afterChange', this.afterSlideChange.bind(this));

    /**
     * Initialise slick on our slideshow
     */
    this.$slideshow.slick(this.settings);

    // this.$pause.on('click', this._togglePause.bind(this));
  }


  slideshow.prototype = $.extend({}, slideshow.prototype, {

    init: function(event, obj) {
      this.$slideshowList = obj.$list;
      this.$slickDots = obj.$dots;
      this.$allSlides = obj.$slides;
      this.slideCount = obj.slideCount;

      // Add an init class to slideshow
      this.$slideshow.addClass(classes.init);

      // Run function for accessibility features
      this._a11y();

      /**
       * Slick Slider clones slides when using infinite mode. We want to ensure
       * these cloned slides are lazy loaded.
       */ 
      this._clonedLazyloading();
    },


    // Use this to add an animation on slide change
    beforeSlideChange: function(event, slick, currentSlide, nextSlide) {
      var $slider = slick.$slider;
      var $currentSlide = $slider.find(selectors.currentSlide).addClass(classes.animateOut);
    },


    // Use this to remove an animation on slide change
    afterSlideChange: function(event, slick, currentSlide) {
      var $slider = slick.$slider;
      var $allSlides = $slider.find(selectors.allSlides).removeClass(classes.animateOut);
    },


    // Destroy slideshow function
    destroy: function() {
      this.$slideshow.slick('unslick');
    },


    /**
     * Playback and Pause functions
     * Primarily used for keyboard accessibility
     */
    _play: function() {
      this.$slideshow.slick('slickPause');
      $(selectors.pauseButton).addClass(classes.isPaused);
    },

    _pause: function() {
      this.$slideshow.slick('slickPlay');
      $(selectors.pauseButton).removeClass(classes.isPaused);
    },

    _togglePause: function() {
      var slideshowSelector = this._getSlideshowId(this.$pause);
      if (this.$pause.hasClass(classes.isPaused)) {
        this.$pause.removeClass(classes.isPaused);
        $(slideshowSelector).slick('slickPlay');
      } else {
        this.$pause.addClass(classes.isPaused);
        $(slideshowSelector).slick('slickPause');
      }
    },


    /**
     * Helper functions
     */
    _getSlideshowId: function($el) {
      return '#Slideshow-' + $el.data('id');
    },

    _activeSlide: function() {
      return this.$slideshow.find('.slick-active');
    },

    _currentSlide: function() {
      return this.$slideshow.find('.slick-current');
    },

    _nextSlide: function(index) {
      return this.$slideshow.find('.slideshow__slide[data-slick-index="' + index + '"]');
    },



    /**
     * A11Y Accessibility Function
     */
    _a11y: function() {
      var $list = this.$slideshowList;
      var autoplay = this.settings.autoplay;

      // Defensive code to check that slideshow exists
      if (!$list) {
        return;
      }

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');


      /**
       * When an element in the slider is focused, pause the slideshow and set
       * aria-live. This is needed only if autoplay is enabled.
       */
      $(selectors.slideshowWrapper).on('focusin', function(evt) {
        if (!$(selectors.slideshowWrapper).has(evt.target).length) {
          return;
        }

        $list.attr('aria-live', 'polite');
        if (autoplay) {
          this._pause();
        }
      }.bind(this));


      /**
       * Resume autoplay when a slide is focused out
       */
      $(selectors.slideshowWrapper).on('focusout', function(evt) {
        if (!$(selectors.slideshowWrapper).has(evt.target).length) {
          return;
        }

        $list.removeAttr('aria-live');
        if (autoplay) {
          this._play();
        }
      }.bind(this));
    },




    /**
     * Cloned Lazy Loading
     * When using the infinite setting on Slick Slider, we get cloned slides.
     * We ensure that lazyloading works on cloned slides.
     */

    _clonedLazyloading: function() {
      var $slideshow = this.$slideshow;

      $slideshow.find('.slick-slide').each(function(index, el) {
        var $slide = $(el);

        if ($slide.hasClass('slick-cloned')) {

          // Get the slideId which is the block.id stored in a data attribute
          var slideId = $slide.data('id');
          var $slideImg = $slide.find('.slide__image').removeClass('lazyloading').addClass('lazyloaded');

          /**
           * Get inline style attribute from non-cloned slide with arbitrary 
           * timeout so the image is loaded
           */
          setTimeout(function() {
            var loadedImageStyle = $slideshow.find('.slide--' + slideId + ':not(.slick-cloned) .slide__image').attr('style');

            if (loadedImageStyle) {
              $slideImg.attr('style', loadedImageStyle);
            }

          }, this.settings.autoplaySpeed / 1.5);

        }
      }.bind(this));
    }

  });

  return slideshow;
})();










/*==============================================================================
  #Drawers

   - Largely based off Shopify Timber Drawers, with inspiration from Pushy JS,
      and Drawer.js
    
    WHAT IT DOES:
    - This allows us to create multiple off-canvas drawers
    - We use a constructor function and create an instance for each drawer we
      would like
    - We use prototypes to add methods to our constructor that can be shared
      amongst all our drawer instances
    - Due to using prototypes, we must use `this.[property]` to expose variables
      to our prototype methods.

    HOW TO USE:
    - Create an instance of a drawer such as:

    var drawerVariableName = new Drawer(drawerId, drawerName)
==============================================================================*/

theme.Drawers = (function() {

  function Drawer(drawerId, drawerName) {

    this.id = drawerId;
    this.name = drawerName;

    this.selectors = {
      html: document.documentElement,
      body: 'body',
      MainContent: '#MainContent',
      overlay: '.page-overlay',

      openBtn: '.js-drawer-open-' + drawerName,
      closeBtn: '.js-drawer-close-' + drawerName
    };

    this.cache = {
      $html: $(this.selectors.html),
      $body: $(this.selectors.body),
      $parent: $(this.selectors.html),
      $mainContent: $(this.selectors.mainContent),
      $overlay: $(this.selectors.overlay),

      $openBtn: $(this.selectors.openBtn),
      $closeBtn: $(this.selectors.closeBtn)
    };

    // Config object
    this.config = {
      open: 'js-drawer-is-open',
      noScroll: 'no-scroll',

      activeDrawer: 'drawer--is-open',
      activeOverlay: 'page-overlay--is-visible',

      namespace: '.drawer-' + name
    };

    // cache our drawer
    this.$drawer = $('#' + this.id);

    // Check if drawer exists
    if (!this.$drawer.length) {
      return false;
    }

    // Drawer flag to indicate if open or closed
    this.drawerIsOpen = false;

    // Last focus variable which will store the element that was focused prior
    // to opening the drawer
    this.$lastFocus = null;

    // Initialise our drawers
    this.init();
  };


  Drawer.prototype = $.extend({}, Drawer.prototype, {

    /* Drawer Init
     ======================================================================== */
    init: function() {
      var $openBtn = this.cache.$openBtn;

      // Attach aria-attributes on initialisation
      $openBtn.attr({
        'aria-controls': '#' + this.id,
        'aria-expanded': 'false'
      });

      /**
       * Open event handler. We use `.bind` to ensure that `this` refers to our 
       * Drawer object, not the jQuery object that is handling our event.
       */    
      $openBtn.on('click' + this.config.namespace, this.open.bind(this));
    },


    /* Drawer Open
     ======================================================================== */
    open: function(evt) {

      /**
       * When opening a drawer via a link we want to prevent the default 
       * behaviour of a link click event.
       *
       * When we open a drawer externally such as a Cart Drawer opening when 
       * an item is added to cart, `evt.preventDefault` encounters an error 
       * because there is no event, so evt is undefined.
       *
       * So, we use a conditional statement to check if our a drawer is opened
       * through an event/link click or externally.
       */
      if (evt) {
        evt.preventDefault();
      }

      // Defensive code to ensure that you can't open an already opened drawer
      if (this.drawerIsOpen) {
        return;
      }

      // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer. Doesn't cause issues for me.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();

        // save the source of the click, we'll focus to this on close
        this.$activeSource = $(evt.currentTarget);
      }


      // Store our last focused element before opening the drawer as jQuery object
      this.$lastFocus = $(document.activeElement);

      // Show drawer
      this.$drawer.addClass(this.config.activeDrawer);

      // Add noScroll class to html/body, and show overlay
      this.cache.$parent.addClass(this.config.noScroll);
      this.cache.$overlay.addClass(this.config.activeOverlay);

      // Set active flag to true
      this.drawerIsOpen = true;

      // Trap focus to drawer
      slate.a11y.trapFocus({
        $container: this.$drawer,
        namespace: 'drawer_focus'
      });

      // Having this trigger, will allow us to close any modals/other elements
      // that may affect the drawer. An example is if we use a quickview modal
      // and add to cart, we want to close the modal, and open the cart drawer.
      $('body').trigger('drawerOpen.' + this.id);

      // Aria-expanded to true
      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'true');
      }

      // Bind close drawer event handlers
      this.bindEvents();
    },


    /* Drawer Close
     ======================================================================== */
    close: function() {

      // Defensive code to ensure you can't close a closed drawer
      if (!this.drawerIsOpen) {
        return;
      }

      // deselect any focused form elements
      $(document.activeElement).trigger('blur');

      // Close drawer
      this.$drawer.removeClass(this.config.activeDrawer);

      // Remove noScroll and hide overlay
      this.cache.$parent.removeClass(this.config.noScroll);
      this.cache.$overlay.removeClass(this.config.activeOverlay);

      // Set flag to false
      this.drawerIsOpen = false;

      // Remove focus
      slate.a11y.removeTrapFocus({
        $container: this.$drawer,
        namespace: 'drawer_focus'
      });

      // Aria-expanded to false
      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'false');
      }

      // Return focus to the element prior to opening our drawer    
      if (this.$lastFocus !== null) {
        this.$lastFocus.focus();     
      }

      // Unbind close drawer event handlers
      this.unbindEvents();
    },



    /* Drawer Bind Events
    ========================================================================= */
    bindEvents: function() {

      // Close on click of close button
      this.cache.$closeBtn.on('click' + this.config.namespace, this.close.bind(this));

      // Close on click of overlay
      this.cache.$overlay.on('click' + this.config.namespace, function (evt) {
          this.close();
      }.bind(this));

      // Close on keypress of escape key
      this.cache.$parent.on('keyup' + this.config.namespace, function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));
    },


    /* Drawer Unbind Events
    ========================================================================= */
    unbindEvents: function() {
      this.cache.$parent.off(this.config.namespace);
      this.cache.$overlay.off(this.config.namespace);
      this.cache.$closeBtn.off(this.config.namespace);
    }

  });

  return Drawer;
})();










/*==============================================================================
  #Modals
==============================================================================*/

theme.Modals = (function(){

  function Modal(modalId, modalName) {

    this.id = modalId;
    this.name = modalName;

    this.selectors = {
      html: document.documentElement,
      body: 'body',
      MainContent: '#MainContent',
      overlay: '.modal-overlay',

      openBtn: '.js-modal-open-' + this.name,
      closeBtn: '.js-modal-close'
    }


    this.cache = {
      $html: $(this.selectors.html),
      $body: $(this.selectors.body),
      $parent: $(this.selectors.html),
      $mainContent: $(this.selectors.mainContent),
      $overlay: $(this.selectors.overlay),

      $openBtn: $(this.selectors.openBtn),
      $closeBtn: $(this.selectors.closeBtn)
    };


    this.config = {
      open: 'js-modal-is-open',
      activeModal: 'modal--is-open',
      activeOverlay: 'modal-overlay--is-visible',
      noScroll: 'no-scroll--modal',

      namespace: '.modal-' + this.name,
      closeOffContentClick: true
    };

    // cache our modal
    this.$modal = $('#' + this.id);

    // check if modal exists
    if (!this.$modal.length) {
      return false;
    }

    // Modal flag to indicate if open or closed
    this.modalIsOpen = false;

    this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal;

    this.isSolid = this.config.solid;

    // Last focus variable which will store the element that was focused prior
    // to opening the drawer
    // this.$lastFocus = null;

    // Initialise our modals
    this.init();
  }


  Modal.prototype = $.extend({}, Modal.prototype, {

    init: function() {
      
      var $openBtn = this.cache.$openBtn;

      // Add aria controls
      $openBtn.attr({
        'aria-controls': '#' + this.id,
        'aria-expanded': 'false'
      });


      /**
       * Open event handler. We use `.bind` to ensure that `this` refers to our 
       * Drawer object, not the jQuery object that is handling our event.
       */    
      $openBtn.on('click' + this.config.namespace, this.open.bind(this));


      // Close modal if a drawer is opened. We have a custom event trigger of
      // drawerOpen set in theme.Drawers.open
      $('body').on('drawerOpen', function() {
        this.close();
      }.bind(this));
    },


    open: function(evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;

      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }

      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }

      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();

        // save the source of the click, we'll focus to this on close
        this.$activeSource = $(evt.currentTarget);
      }

      if (this.modalIsOpen && !externalCall) {
        this.close();
      }

      this.$modal.addClass(this.config.activeModal);

      this.cache.$parent.addClass(this.config.noScroll);
      this.cache.$overlay.addClass(this.config.activeOverlay);

      // Set active flag to true
      this.modalIsOpen = true;

      // slate.a11y.trapFocus({
      //   $container: this.$modal,
      //   $elementToFocus: this.$focusOnOpen,
      //   namespace: 'modal_focus'
      // });

      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'true');
      };

      // Add an event trigger if we ever need this
      $('body').trigger('modalOpen.' + this.id);

      // If using search modal, focus on search input
      if (this.name == 'search') {
        $('.search__input').focus();
      }

      // Bind close modal event handlers
      this.bindEvents();
    },


    close: function(evt) {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }

      // deselect any focused form elements
      $(document.activeElement).trigger('blur');


      this.$modal.removeClass(this.config.activeModal);

      this.cache.$parent.removeClass(this.config.noScroll);
      this.cache.$overlay.removeClass(this.config.activeOverlay);

      // Set active flag to false
      this.modalIsOpen = false;

      // slate.a11y.removeTrapFocus({
      //   $container: this.$modal,
      //   namespace: 'modal_focus'
      // });

      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'false').focus();
      }

      $('body').trigger('modalClose.' + this.id);

      this.unbindEvents();
    },


    bindEvents: function(evt) {

      // Close on click of close button
      this.cache.$closeBtn.on('click' + this.config.namespace, this.close.bind(this));

      // Close on click of overlay
      this.cache.$overlay.on('click' + this.config.namespace, function (evt) {
          this.close();
      }.bind(this));

      // Close on keypress of escape key
      this.cache.$parent.on('keyup' + this.config.namespace, function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));

    },


    unbindEvents: function(evt) {
      this.cache.$parent.off(this.config.namespace);
      this.cache.$overlay.off(this.config.namespace);
      this.cache.$closeBtn.off(this.config.namespace);
    }

  });

  return Modal;
})();










/*==============================================================================
  #Collapsibles
==============================================================================*/

theme.Collapsibles = (function() {

  var selectors = {
    collapsiblesWrapper: '.collapsibles-wrapper',
    collapsible: '.collapsible',
    button: '.collapsible__heading',
    contentWrapper: '.collapsible__panel',
    content: '.collapsible__panel-content',
    activeCollapsible: '.collapsible--is-open'
  };

  var config = {
    activeCollapsible: 'collapsible--is-open',
    keepMultipleOpen: false
  }


  function init() {
    // Event handler on click
    $(selectors.button).on('click', function(evt) {

      var $el = $(this);

      // If we have a `data-keep-multiple-open="true"` attribute on the
      // collapsible, we set the flag to true.
      if ($el.data('keep-multiple-open') === true) {
        config.keepMultipleOpen = true;
      }

      // We store the target in a jQuery object
      var $target = $(evt.target);

      // If we have nested collapsibles, we ensure that click events don't bubble
      // so a nested collapsible doesn't open and then close.
      evt.stopPropagation();

      // Pass our $target to toggleCollapsible function
      toggleCollapsible($target);
    });
  };


  // Pass in our $target element (the button that was clicked)
  function toggleCollapsible($target) {

    // Get the parent collapsible
    var $parentCollapsible = $target.closest(selectors.collapsible);

    // We check if the collapsible is open or closed and run the relevant
    // function, passing in the parentCollapsible and the target element
    if ($parentCollapsible.hasClass(config.activeCollapsible)) {
      closeCollapsible($parentCollapsible, $target);
    } else {
      openCollapsible($parentCollapsible, $target);
    }

    // If we want only one collapsible to open at a time, we run this function
    // to close sibling collapsibles.
    if (!config.keepMultipleOpen) {
      $parentCollapsible.siblings(selectors.collapsible).each(function(index, element) {
        var $element = $(element);
        closeCollapsible($element);
      });
    }
  }


  // Open collapsible - pass in parentCollapsible and target
  function openCollapsible($parentCollapsible, $target) {

    // If already open, skip this function
    if ($parentCollapsible.hasClass(config.activeCollapsible)) {
      return;
    }

    // Ensure we are using the right toggleButton
    var $toggleButton = $parentCollapsible.find('> ' + selectors.button);

    // Add active class
    $parentCollapsible.addClass(config.activeCollapsible);

    // Add aria expanded
    $toggleButton.attr('aria-expanded', true);
  }


  function closeCollapsible($parentCollapsible, $target) {

    // If already closed, skip this function
    if (!$parentCollapsible.hasClass(config.activeCollapsible)) {
      return;
    }

    // Ensure we are using the right toggleButton
    var $toggleButton = $parentCollapsible.find('> ' + selectors.button);

    // Remove active class
    $parentCollapsible.removeClass(config.activeCollapsible);

    // Add aria expanded
    $toggleButton.attr('aria-expanded', false);
  }


  return {
    init: init
  };
})();










/*==============================================================================
  #Tabs
==============================================================================*/

theme.Tabs = (function() {

  var selectors = {
    tabs: '.tabs',
    tabTrigger: '[data-tab-trigger]',
    tabPanel: '.tab__panel',
    tabIsActive: '.tab--is-active'
  };

  var cache = {
    $tabs: $(selectors.tabs),
    $tabTrigger: $(selectors.tabTrigger),
    $tabPanel: $(selectors.tabPanel)
  };  

  var config = {
    tabIsActive: 'tab--is-active'
  };


  function init() {
    // Event handler on click
    cache.$tabTrigger.on('click', function(evt) {

      evt.preventDefault();

      var $this = $(this);
      var panelId = $this.attr('data-tab-trigger');

      cache.$tabTrigger.removeClass(config.tabIsActive);
      cache.$tabPanel.removeClass(config.tabIsActive);

      $this.addClass(config.tabIsActive);
      $('[data-tab-panel="' + panelId + '"]').addClass(config.tabIsActive);
    });
  };

  return {
    init: init
  };
})();










/*==============================================================================
  #ajaxCartUtilities

  Utilties to work with the Shopify AJAX API
==============================================================================*/

theme.ajaxCartUtilities = {
  getCart: function() {
    return $.getJSON('/cart.js');
  },

  changeItem: function(key, qty) {
    return this._updateCart({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + qty + '&id=' + key,
      dataType: 'json'
    });
  },

  addItemFromForm: function(data) {
    return this._updateCart({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json'
    });
  },

  /**
   * #BOLD PRODUCT OPTIONS
   * Edited to work with Bold Product Optons
   */
  _updateCart: function(params) {
    return $.ajax(params)
      .then(function(cart) {
      // Bold:POv2 - Update bold cart.
      if(typeof window.BOLD !== 'undefined'
         && typeof window.BOLD.common !== 'undefined'
         && typeof window.BOLD.common.cartDoctor !== 'undefined') {
        // NOTE: "cart" should be the variable containing the cart json data
        cart = window.BOLD.common.cartDoctor.fix(cart);
      }
      // Bold:POv2  
        return cart;
      }.bind(this))
  },

  /**
   * #BOLD PRODUCT OPTIONS
   * Edited to work with Bold Product Optons
   */
  updateNote: function(note) {
    var params = {
      type: 'POST',
      url: '/cart/update.js',
      data: 'note=' + theme.ajaxCartUtilities.attributeToString(note),
      dataType: 'json',
      success: function(cart) {
        // Bold:POv2 - Update bold cart.
        if(typeof window.BOLD !== 'undefined'
           && typeof window.BOLD.common !== 'undefined'
           && typeof window.BOLD.common.cartDoctor !== 'undefined') {
          // NOTE: "cart" should be the variable containing the cart json data
          cart = window.BOLD.common.cartDoctor.fix(cart);
        }
        // Bold:POv2  
      },
      error: function(XMLHttpRequest, textStatus) {}
    };

    $.ajax(params);
  },

  attributeToString: function(attribute) {
    if ((typeof attribute) !== 'string') {
      attribute += '';
      if (attribute === 'undefined') {
        attribute = '';
      }
    }
    return $.trim(attribute);
  }
}










/*==============================================================================
  #theme.AjaxProduct

  - If AJAX functionality is enabled, this will take a product form, and
    ajaxify it
==============================================================================*/

theme.AjaxProduct = (function() {

  // Add a loading flag
  var status = {
    loading: false
  };

  function ProductForm($form) {
    // Store form and add to cart btn variables
    this.$form = $form;
    this.$addToCart = this.$form.find('.js-add-to-cart-btn');

    // If form exists, add event handler
    if (this.$form.length) {
      this.$form.on('submit', this.addItemFromForm.bind(this));
    }
  };


  ProductForm.prototype = $.extend({}, ProductForm.prototype, {

    // Product add event
    addItemFromForm: function(evt, callback){

      // Prevent default form submission behaviour
      evt.preventDefault();

      // If form is still loading, return
      if (status.loading) {
        return;
      }

      // Loading indicator on add to cart button
      this.$addToCart.addClass('btn--loading');

      // Set loading to true
      status.loading = true;

      // Convert form data to text for AJAX request
      var data = this.$form.serialize();



      /**
       * #BOLD PRODUCT OPTIONS
       *
       * Run theme.ajaxCartUtilities.addItemFromForm AJAX function and pass our product form.
       * On success, we run success function.
       * On error we run error function.
       * On completion we reset our loading flags and classes.
       */
        // Bold:POv2 - Use our add-to-cart functionality to enable file uploads with AJAX.
      var success_callback = function(product) {
        // Bold:POv2   
        if(typeof window.BOLD !== 'undefined'
           && typeof window.BOLD.common !== 'undefined'
           && typeof window.BOLD.common.cartDoctor !== 'undefined') {
          // NOTE: "item" should be the variable containing the item json data from the cart/add.js response
          product = window.BOLD.common.cartDoctor.fixItem(product);
        }
        // Bold:POv2
        this.success(product);
      }.bind(this);
      var error_callback = function(XMLHttpRequest) {
        this.error(XMLHttpRequest)
      }.bind(this);
      var complete_callback = function() {
        status.loading = false;
        this.$addToCart.removeClass('btn--loading');
      }.bind(this);
      if(typeof(BOLD)==='object' && BOLD.helpers && typeof(BOLD.helpers.addItemFromForm) === 'function') {
        BOLD.helpers.addItemFromForm(this.$form, success_callback, error_callback, {endpoint:'/cart/add.js'});     
        complete_callback();       
      } else {
        theme.cart.addItemFromForm(data)
        .then(success_callback)
        .catch(error_callback)
        .always(complete_callback);
      } 
      // Bold:POv2 
    },

    /**
     * On success, we remove any existing error message, and set a trigger for
     * `added.ajaxProduct` event listener which is in `theme.CartSection``
     */
    success: function(product) {
      this.$form.find('.alert--error').remove();
      $('body').trigger('added.ajaxProduct');
    },


    /**
     * On error, we remove any existing errors.
     * We store the error messages and print to the console and the DOM
     */
    error: function(XMLHttpRequest) {
      this.$form.find('.alert--error').remove();

      if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
        console.warn(XMLHttpRequest.responseJSON.description);

        this.$form.prepend('<div class="form__alert alert  alert--error">' + XMLHttpRequest.responseJSON.description + '</div>');
      }
    }
  });

  return ProductForm;
})();










/*==============================================================================
  #theme.currencySwitcher
==============================================================================*/

theme.currencySwitcher = (function() {

  var selectors = {
    dataDiv: '#CurrencyData',
    picker: '.js-currency-selector'
  }

  var data = {};

  function init() {
    console.log('init currency');

    var $dataDiv = $(selectors.dataDiv);

    if (!$dataDiv.length) {
      return;
    }

    data = {
      currency: $dataDiv.data('shop-currency'),
      default: $dataDiv.data('default-currency'),
      format: $dataDiv.data('format'),
      moneyFormat: $dataDiv.data('money-format'),
      moneyCurrencyFormat: $dataDiv.data('money-currency-format')
    };

    Currency.format = data.format;

    // Rely on the shop's currency format, not Shopify defaults (in case merchant changes it)
    Currency.money_format[data.currency] = data.moneyFormat;
    Currency.money_with_currency_format[data.currency] = data.moneyCurrencyFormat;

    // Save current price
    $('span.money').each(function() {
      $(this).attr('data-currency-' + data.currency, $(this).html());
    });

    checkCookie();

    $(selectors.picker).val(Currency.currentCurrency).on('change', refresh);
  }

  function refresh() {
    console.log('refresh');

    var newCurrency = $(selectors.picker).val();
    Currency.convertAll(Currency.currentCurrency, newCurrency);
  }

  function ajaxRefresh() {

    console.log('run ajaxRefresh');
    var newCurrency = $(selectors.picker).val();
    console.log(data.currency, newCurrency);

    // Ajax cart always returns shop's currency, not what theme settings defines
    Currency.convertAll(data.currency, newCurrency);
  }

  function checkCookie() {
    var cookieCurrency = Currency.cookie.read();

    if (cookieCurrency == null) {
      if (data.currency !== data.default) {
        Currency.convertAll(data.currency, data.default);
      }
      else {
        Currency.currentCurrency = data.default;
      }
    } else if ($(selectors.picker).length && $(selectors.picker).find('option[value=' + cookieCurrency + ']').length === 0) {
      // If the cookie value does not correspond to any value in the currency dropdown
      Currency.currentCurrency = data.currency;
      Currency.cookie.write(data.currency);
    }
    else if (cookieCurrency === data.currency) {
      Currency.currentCurrency = data.currency;
    }
    else {
      Currency.convertAll(data.currency, cookieCurrency);
    }
  }

  return {
    init: init,
    refresh: refresh,
    ajaxRefresh: ajaxRefresh
  };

})();


















/*==============================================================================
  #SECTIONS
==============================================================================*/

/*==============================================================================
  #Product
==============================================================================*/

theme.Product = (function() {

  var selectors = {
    currentSlide: '.slick-current',
    zoomImage: '.product__image--zoom--initial'
  };

  var config = {
    zoomInit: 'product__image-slide--init-zoom',
    activeZoom: 'image-is-zoomed'
  };

  function Product(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);

    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    this.settings = {
      enableHistoryState: this.options['enableHistoryState'],
      namespace: '.product-' + sectionId,

      enableImageZoom: this.options['enableImageZoom'],
      slickMainInitialized: false,
      slickThumbInitialized: false,
      hasImages: true,
      hasMultipleImages: false,
      imageSize: '620x',

      variantStyle: this.options['variantStyle'],
      linkProductOptions: this.options['linkProductOptions'],
      enableSwatches: this.options['enableSwatches'],
      selectDefaultVariant: this.options['selectDefaultVariant'],
      useAjaxCart: this.options['useAjaxCart']
    };

    this.selectors = {
      productJson: 'ProductJson-' + sectionId,

      productImageWrapper: '.product__image-wrapper--' + sectionId,
      productThumbImageWrapper: '.product__thumb-wrapper--' + sectionId,
      productMainSlider: '.js-product-slider--' + sectionId,
      productThumbSlider: '.js-product-thumbs-slider--' + sectionId,

      price: '.product__price-' + sectionId,
      comparePrice: '.product__price--compare-' + sectionId,

      addToCart: '.js-add-to-cart-btn--' + sectionId,
      addToCartText: '.js-add-to-cart-text--' + sectionId,

      originalSelectorId: '#ProductSelect-' + sectionId,
      singleOptionSelector: '.variant-selector-' + sectionId,
      variantColorSwatch: '.variant__input--color-swatch-' + sectionId,

      formContainer: '#AddToCartForm-' + sectionId,

      qtyDecrease: '[data-action="decrease-quantity"]',
      qtyIncrease: '[data-action="increase-quantity"]'
    };


    // Check this is a product object
    if (!$('#' + this.selectors.productJson).html()) {
      return;
    }

    // Parse our product json object
    this.productObject = JSON.parse(document.getElementById(this.selectors.productJson).innerHTML);


    // Cache slider and image variables
    this.$productMainSlider = $(this.selectors.productMainSlider);
    this.$productThumbSlider = $(this.selectors.productThumbSlider);

    // We get our first product image
    this.$firstProductImage = this.$productMainSlider.find('img').first();


    // Defensive code to check if images exist
    if (!this.$firstProductImage.length) {
      this.settings.hasImages = false;
    }

    // Initialise section
    this.init();

  }

  Product.prototype = $.extend({}, Product.prototype, {

    init: function() {
      this.productFormSetup();

      this.productImageSetup();
      this.createImageCarousels();
    },

    productFormSetup: function() {
      this.initQtySelector();
      this.initAjaxProductForm();
      this.initVariants();
    },

    productImageSetup: function() {
      this.setImageSizes();
      this.initImageSwitch();
    },


    initVariants: function() {

      var options = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        variantStyle: this.settings.variantStyle,
        linkProductOptions: this.settings.linkProductOptions,
        enableSwatches: this.settings.enableSwatches,
        selectDefaultVariant: this.settings.selectDefaultVariant,
        product: this.productObject
      };

      if (options.selectDefaultVariant) {
        this.variants = new slate.Variants(options);
      } else {
        this.variants = new theme.CustomVariants(options);
      }


      /**
       * If we're using buttons, we run some different functions and register
       * different event handlers.
       */
      if (options.variantStyle == 'buttons') {

        // If we link product options, we register our updateVariantButtons
        // event handler, and run linkOptionSelectors to set things up
        if (options.linkProductOptions) {
          this.optionsMap = {};

          this.$container.on('variantButtonChange' + this.settings.namespace, this.updateVariantButtons.bind(this));

          this._linkOptionSelectors(options.product);
        }

        // If we are using color swatches and have a color swatch name variable
        // we update the color name on swatch change.
        if (options.enableSwatches && $(this.selectors.variantColorSwatch).length) {
          $(this.selectors.variantColorSwatch).on('change', function(evt) {
            var $el = $(evt.currentTarget);
            var color = $el.data('color-name');
            var index = $el.data('color-index');
            this.updateColorName(color, index);
          }.bind(this));
        }

      };


      this.$container.on('variantPriceChange' + this.settings.namespace, this.updatePrice.bind(this));
      this.$container.on('variantChange' + this.settings.namespace, this.updateCartButton.bind(this));
      this.$container.on('variantImageChange' + this.settings.namespace, this.updateVariantImage.bind(this));
    },


    updatePrice: function(evt) {

      var optionChangeWithNoVariant = evt.optionChangeWithNoVariant;
      var variant = evt.variant;

      if (optionChangeWithNoVariant) {
        return;
      }

      if (variant) {

        if (variant.available) {
          
          // #BOLD
          if(window.BOLD && BOLD.common && BOLD.common.eventEmitter && BOLD.common.eventEmitter.on){ 
            BOLD.common.eventEmitter.emit('BOLD_COMMON_variant_changed', variant)
          }

          // Update current price
          $(this.selectors.price).html(slate.Currency.formatMoney(variant.price, theme.settings.moneyFormat));

          if (variant.compare_at_price > variant.price) {

            // If on sale, update compare at price (aka regular price)
            $(this.selectors.comparePrice).html(slate.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat));

          }

        } else {
          $(this.selectors.price).text('');
        }
        // Bold:POv2 - Include variant selector change emitter in relation to option price to update product price.
        typeof BOLD !== 'undefined'
        && typeof BOLD.common !== 'undefined'
        && BOLD.common.eventEmitter !== 'undefined'
        && BOLD.common.eventEmitter.emit('BOLD_COMMON_variant_changed', { variant: variant });
        // Bold:POv2
      }
      
    },


    updateCartButton: function(evt) {

      var $buttonSeparator = $('.product__btn-separator');
      var hideClass = 'product__btn-separator--hide';

      var optionChangeWithNoVariant = evt.optionChangeWithNoVariant;
      var variant = evt.variant;

      if (optionChangeWithNoVariant) {
        return;
      }

      if (variant) {

        if (variant.available) {

          // Remove disabled attribute and show Add to Cart text
          $(this.selectors.addToCart).prop('disabled', false);
          $(this.selectors.addToCartText).html(theme.strings.addToCart);
          $buttonSeparator.removeClass(hideClass);

        } else {

          // Add disabled attribute and show Sold Out text
          $(this.selectors.addToCart).prop('disabled', true);
          $(this.selectors.addToCartText).html(theme.strings.soldOut);
          $buttonSeparator.addClass(hideClass);
        }

      } else {

        // If variant does not exist 
        // Add disabled attribute and show Unavailable text
        $(this.selectors.addToCart).prop('disabled', true);
        $(this.selectors.addToCartText).html(theme.strings.unavailable);
        $buttonSeparator.addClass(hideClass);
      }
    },


    updateVariantImage: function(evt) {
      
      // variantImageChange evt stores our variant object
      var variant = evt.variant;

      // These size variables aren't needed for current slider implementation
      // var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
      // var zoomSizedImgUrl;

      // if (this.settings.enableImageZoom && theme.config.isTouch) {
      //   zoomSizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageZoomSize);
      // }


      // Retrieve index of our new image
      var $newImage = $('.product__thumb-wrapper[data-id="' + variant.featured_image.id + '"]');
      var imageIndex = this._slideIndex($newImage.closest('.product__thumb-slide'));

      // If there is no index, slider is not initalized
      if (typeof imageIndex === 'undefined') {
        return;
      }

      // Go to slide
      this.$productMainSlider.slick('slickGoTo', imageIndex);
    },


    // Variant swatch color name change function
    updateColorName: function(color, index) {
      // Updates on radio button change, not variant.js
      $('#VariantColorLabel-' + this.sectionId + '-' + index).text(color);
    },


    // When using buttons and linked options, this function checks how many
    // product options we have, and runs our updateOptionsInSelector function
    // which will show available/in-stock items
    updateVariantButtons: function(evt) {
      var self = this;

      this._updateOptionsInSelector(0);

      if (self.productObject.options.length > 1) {
        this._updateOptionsInSelector(1);
      }

      if (self.productObject.options.length === 3) {
        this._updateOptionsInSelector(2);
      }
    },


    // This sets up our linked product options
    _linkOptionSelectors: function(product) {

      // Loop over product variants
      for (var i = 0; i < product.variants.length; i++) {

        // Store variant
        var variant = product.variants[i];

        if (variant.available) {

          this.optionsMap.root = this.optionsMap.root || [];

          // For each variant we push the first option as our root. Our linked
          // options work relative to the root value
          this.optionsMap.root.push(variant.option1);

          // This ensures we don't have duplicate root values. For example:
          // If we had 20 variants with the color Navy, we only need Navy to
          // appear once in our optionsMap.root
          this.optionsMap.root = slate.utils.uniq(this.optionsMap.root);


          // If we have 2 product options, then we run our linked options

          if (product.options.length > 1) {

            // This will store the value of variant option1. E.g. if our first
            // option is Color, we will store the value such as Navy or Red
            // We store this as our key in key/value pairs
            var key = variant.option1;

            this.optionsMap[key] = this.optionsMap[key] || [];

            // This will store the value of our variant option2 as the VALUE
            // of our key/value pair. E.g. if `Navy is our key, we will store
            // `size 4`` as our pair
            this.optionsMap[key].push(variant.option2);

            // This ensures we don't have duplicate values
            this.optionsMap[key] = slate.utils.uniq(this.optionsMap[key]);
          }


          // If we have 3 product options

          if (product.options.length === 3) {

            // We store the values of option1 and option2 as our key. E.g.
            // `Navy / Size 4`
            var key = variant.option1 + " / " + variant.option2;

            this.optionsMap[key] = this.optionsMap[key] || [];

            // We store the value of option3 as our VALUE in the key/value pairs
            this.optionsMap[key].push(variant.option3);

            // This ensures we don't have duplicate values
            this.optionsMap[key] = slate.utils.uniq(this.optionsMap[key]);
          }

        }
      }

      // Now that we've linked our option selectors and created an optionsMap
      // object, we can actually run the code.

      // We run the code on load
      this._updateOptionsInSelector(0);

      // If we have 2 product options, we pass in the number of product options. 
      // Remember that JS indexing is zero-based so we pass in 1
      if (product.options.length > 1) {
        this._updateOptionsInSelector(1);
      }

      // If we have 3 product options, we pass in the options index value. 
      // Remember that JS indexing is zero-based so we pass in 2
      if (product.options.length > 1) {
        this._updateOptionsInSelector(2);
      }

    },


    // When using buttons and linked options, this function updates the buttons
    // to show what is available/in-stock
    _updateOptionsInSelector: function(numberOfOptions) {

      var $formContainer = $(this.selectors.formContainer);

      // We use a switch statement based on the number of product options
      switch (numberOfOptions) {
        case 0:
          var key = "root";
          // var selector = $(".single-option-radio:eq(0)", this.selectors.formContainer);
          var selector = $formContainer.find('.variant-selector__wrapper--buttons:eq(0)');
          break;
        case 1:
          // var key = $("input:checked", this.selectors.formContainer + " .single-option-radio:eq(0)").val();
          var key = $formContainer.find(".variant-selector__wrapper--buttons:eq(0) input:checked").val();
          // var selector = $(".single-option-radio:eq(1)", this.selectors.formContainer);
          var selector = $formContainer.find('.variant-selector__wrapper--buttons:eq(1)');
          break;
        case 2:
            // var key = $("input:checked", this.selectors.formContainer + " .single-option-radio:eq(0)").val();
            var key = $formContainer.find(".variant-selector__wrapper--buttons:eq(0) input:checked").val();
            // key += " / " + $("input:checked", this.selectors.formContainer + " .single-option-radio:eq(1)").val();
            key += " / " + $formContainer.find(".variant-selector__wrapper--buttons:eq(1) input:checked").val();
            // var selector = $(".single-option-radio:eq(2)", this.selectors.formContainer)
            var selector = $formContainer.find(".variant-selector__wrapper--buttons:eq(2)");
      };

      // Store available values in an array
      var availableValues = ($("input:checked", selector).val(), this.optionsMap[key]);

      var selectorIndex = numberOfOptions;


      // For each input, check if value is in availableValues
      $formContainer.find('.variant-selector__wrapper--buttons[data-option-index="' + selectorIndex + '"] input.variant__input').each(function() {

          if ($.inArray($(this).val(), availableValues) !== -1) {
            // If available, remove disabled attribute, and soldout class
            $(this).removeAttr('disabled', 'disabled');
            $(this).parent().removeClass("soldout");
          } else {
            // If unavailable, add disabled attribute, and soldout class
            $(this).attr('disabled', 'disabled');
            $(this).parent().addClass("soldout");
          }
      });


      // Store optionWrapper
      var optionWrapper = $formContainer.find('.variant-selector__wrapper--buttons[data-option-index="' + selectorIndex + '"]');


      // Store swatch container
      var swatchContainer = optionWrapper.find("input:checked").parent();

      // Sometimes a user may inadvertently select a sold out variant. This will
      // automatically choose the closest available variant. Not sure whether
      // this is good/bad thing for now. Depends on customer behavior.

      if (this.options.selectDefaultVariant) {
        if (swatchContainer.hasClass("soldout") && swatchContainer.attr("data-variant-swatch-soldout") == "true") {
          var availableSwatch = optionWrapper.find(".swatch-container:not(.soldout)").eq(0);
          availableSwatch.length > 0 && availableSwatch.find("input").trigger("click");

        }
      }

    },


    initQtySelector: function() {
      $(this.selectors.qtyDecrease).on('click', function(evt) {
        var target = evt.currentTarget;
        target.nextElementSibling.value = Math.max(parseInt(target.nextElementSibling.value) - 1, 1);
      });

      $(this.selectors.qtyIncrease).on('click', function(evt) {
        var target = evt.currentTarget;
        target.previousElementSibling.value = parseInt(target.previousElementSibling.value) + 1;
      });
    },


    initAjaxProductForm: function() {
      // If we are using a AJAX drawer, pass our form to AjaxProduct function
      if (theme.settings.cartType === 'drawer') {
        new theme.AjaxProduct($(this.selectors.formContainer));
      }
    },


    /**
     * Retrieves the size of the active image, and the zoomed image if it exists.
     * If we need to dynamically add images, we can use these settings. For now,
     * these aren't really needed.
     */

    setImageSizes: function() {

      // Check that images exist
      if (!this.settings.hasImages) {
        return;
      }

      /**
       * Get srcset image src, which works on most modern browsers. Otherwise
       * defaults to `settings.imageSize`. This doesn't run consistently.
       */
      var currentImage = this.$firstProductImage[0].currentSrc;

      if (currentImage) {
        this.settings.imageSize = slate.Image.imageSize(currentImage);
      }

      // If zoom is enabled, we get the `data-zoom-size` and use that
      if (this.settings.enableImageZoom) {
        this.settings.imageZoomSize = slate.Image.imageSize(this.$firstProductImage.parent().data('zoom-size'));
      }
    },


    /**
     * Configures the thumbnail / image switching behaviour. This works if using
     * `a` elements to wrap our thumbnails, as it will prevent default behaviour.
     * We're not currently using this, but opting for `div` elements and Slick
     * sliders `asNavFor` functionality which links the thumbnail slider to
     * the main slider.
     */

    initImageSwitch: function() {

      // If thumbs don't exist, return
      if (!$(this.selectors.productThumbImageWrapper).length) {
        return;
      }

      var self = this;

      // Prevent default behaviour on click of thumbs
      $(this.selectors.productThumbImageWrapper).on('click', function(evt) {
        evt.preventDefault();
      });
    },


    /**
     * Initialise zoom for product images
     */
    initZoom: function($image) {

      // Get URL of zoomed image which is stored in a data-attribute
      var largeImage = $image.parent().data('zoom-size');

      /**
       * 1. In case we're using an anchor element, we prevent default behaviour.
       * 2. We use a `custom` zoom behaviour that's been added to the zoom.js
       *    script. This allows the user to click to zoom, and exit by either
       *    click or mouseleave events.
       * 3. Set touch to false. However, the zoom still seems to work on iOS.
       */
      $image.parent()
      .on('click', function(evt) {
        evt.preventDefault(); /* [1] */
      })
      .zoom({
        on: 'custom', /* [2] */
        url: largeImage,
        duration: 180,
        touch: false, /* [3] */
        onZoomIn: function() {
          $(this).addClass(config.activeZoom);
        },
        onZoomOut: function() {
          $(this).removeClass(config.activeZoom);
        }
      });
    },


    /**
     * This function currently creates both main and thumb sliders.
     */

    createImageCarousels: function() {

      if (this.settings.enableImageZoom && !theme.config.isTouch) {
        this.initZoom($(this.selectors.productImageWrapper).find(selectors.zoomImage));
      }

      // Check there are multiple images. If not, return.
      if (!this.$productThumbSlider.length || $(this.selectors.productThumbImageWrapper).length < 2) {
        return;
      }

      this.settings.hasMultipleImages = true;

      // Set starting slide for both sliders
      var $activeSlide = this.$productMainSlider.find('.product__image-slide--starting');
      var startIndex = this._slideIndex($activeSlide);

      // Lame way to prevent duplicate event listeners
      this.$productMainSlider.off('init');
      this.$productMainSlider.off('beforeChange');
      this.$productMainSlider.on('init', this.mainSlideInit.bind(this));
      this.$productMainSlider.on('beforeChange', this.beforeSlideChange.bind(this));

      // Default slider settings
      this.productMainSliderArgs = {
        infinite: false,
        arrows: false,
        dots: false,
        adaptiveHeight: true,
        rows: 0,
        initialSlide: startIndex
      };

      // Default thumb slider settings
      this.productThumbSliderArgs = {
        initialSlide: startIndex,
        rows: 0
      };

      // Init sliders 
      var sliderArgs = this.setSliderArgs();
      this.initSliders(sliderArgs);
    },

    initSliders: function(args) {
      this.destroyImageCarousels();

      this.$productMainSlider.slick(args.main);
      this.$productThumbSlider.slick(args.thumbs);

      this.settings.slickThumbInitialized = true;
      this.settings.slickMainInitialized = true;
    },

    setSliderArgs: function() {
      var args = {};
      args.main = $.extend({}, this.productMainSliderArgs, {
        asNavFor: this.selectors.productThumbSlider,
        adaptiveHeight: true,
        fade: true
      });

      args.thumbs = $.extend({}, this.productThumbSliderArgs, {
        asNavFor: this.selectors.productMainSlider,
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        focusOnSelect: true,
        infinite: false,
        prevArrow: $('.thumbs__arrow--prev'),
        nextArrow: $('.thumbs__arrow--next')
        // customSlideAdvancement: true
      });

      return args;
    },

    destroyImageCarousels: function() {
      if (this.$productMainSlider && this.settings.slickMainInitialized) {
        this.$productMainSlider.slick('unslick');
        this.settings.slickMainInitialized = false;
      }

      if (this.$productThumbSlider && this.settings.slickThumbInitialized) {
        this.$productThumbSlider.slick('unslick');
        this.settings.slickThumbInitialized = false;
      }
    },

    mainSlideInit: function(event, slick) {
      var $slider = slick.$slider;
      var $currentSlide = $slider.find(selectors.currentSlide);
    },

    beforeSlideChange: function(event, slick, currentSlide, nextSlide) {
      var $slider = slick.$slider;
      var $currentSlide = $slider.find(selectors.currentSlide);
      var $nextSlide = $slider.find('.slick-slide[data-slick-index="' + nextSlide + '"]');

      // Lazyload zoom image
      if (this.settings.enableImageZoom && !theme.config.isTouch) {
        if ($nextSlide.hasClass(config.zoomInit)) {
          return;
        }
        var $image = $nextSlide.addClass(config.zoomInit).find('img').addClass('lazyload');
        this.initZoom($image);
      }
    },

    // Get slide index
    _slideIndex: function($el) {
      return $el.data('index');
    },

    onSelect: function() {
      theme.Collapsibles.init();
      theme.Tabs.init();
    }

  });

  return Product;

})();










/*==============================================================================
  #HeaderSection
==============================================================================*/

theme.HeaderSection = (function() {

  function Header(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);

    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    var $sectionHeader = this.$sectionHeader = $('.shopify-section--header');

    // Last scroll position used if we have a sticky header
    var lastScrollPosition = this.lastScrollPosition = 0;

    /**
     * If the Sticky Header is enabled we run stickybits as a CSS sticky 
     * fallback for older browsers.
     */
    if (this.options['isSticky']) {
      stickybits('.shopify-section--header');
    }

    /**
     * If we have a transparent header, we want it to lose transparency if a
     * user hovers or focuses on it.
     * When a user removes focus or hover, we want to return to transparent
     * header.
     */
    if (this.options['hasTransparentHeader']) {
      $sectionHeader.on('mouseenter.header', this.focusNavigation);
      $sectionHeader.on('focusin.header', this.focusNavigation);
      $sectionHeader.on('mouseleave.header', this.checkTransparentHeader.bind(this));
      $sectionHeader.on('focusout.header', this.checkTransparentHeader.bind(this));
    }

    /**
     * Used a throttle of 16 that matches 60fps. Need to refactor this to use
     * requestAnimationFrame for improved performance.
     */
    if (this.options['isSticky'] && this.options['hasTransparentHeader']) {
      $(window).on('scroll.header', $.throttle(16, this.checkTransparentHeader).bind(this));
    } else {
      $(window).off('scroll.header');
    }


    /**
     * If using transparent header, we want to ensure that the main content
     * moves up to simulate `position: absolute`. We do this by adding a
     * negative margin equal to the header height.
     */
    if (this.options['hasTransparentHeader']) {

      setHeaderHeight();

      $(window).on('resize', function() {
        setHeaderHeight();
      });
    }

    function setHeaderHeight() {
      var headerHeight = Math.ceil($sectionHeader.height());

      $sectionHeader.css({
        'margin-bottom': -headerHeight + 'px'
      });
    }

    theme.HeaderNav.init();
    this.initDrawers();
    // theme.currencySwitcher.init()
  }

  Header.prototype = $.extend({}, Header.prototype, {

    // Remove transparent header when focused or moused over
    focusNavigation: function() {
      $('.header').removeClass('header--transparent');
    },

    // Check scroll position when using transparent header and sticky
    checkTransparentHeader: function() {
      if (!this.options['hasTransparentHeader']) {
        return;
      }

      // If a dropdown is open, do not run
      if ($('.header-nav__item--main--dropdown-is-open').length) {
        return;
      }

      var scrollPosition = $(window).scrollTop();
      var scrollThreshold = 10;

      if (scrollPosition > scrollThreshold) {
        $('.header').removeClass('header--transparent');
      } else {
        $('.header').addClass('header--transparent');
      }

      this.lastScrollPosition = scrollPosition;
    },

    initDrawers: function() {
      theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');
    },

    // Reinitialise nav JS
    onSelect: function() {
     theme.HeaderNav.init(); 
    }

  });

  return Header;

})();










/*==============================================================================
  #DrawerMenuSection
==============================================================================*/

theme.DrawerMenuSection = (function() {

  function DrawerMenuSection(container) {
    this.init();
  }

  DrawerMenuSection.prototype = $.extend({}, DrawerMenuSection.prototype, {


    init: function() {
      // this.onUnload();

      theme.DrawerMenu = new theme.Drawers('NavDrawer', 'nav');
    },

    /**
     * Shopify Theme Editor events
     */

    forceReload: function() {
      this.init();
    },

    onSelect: function() {
      theme.DrawerMenu.open();
      theme.Collapsibles.init();
    },

    onDeselect: function() {
      theme.DrawerMenu.close();
    },

    onUnload: function() {
      if (theme.DrawerMenu) {
        theme.DrawerMenu.close();
      }
    }
  });

  return DrawerMenuSection;
})();










/*==============================================================================
  #CartSection
  - This handles code for both our standard cart template and our AJAX
    cart drawer
  - We are not using a JS templating library like Handlebars to update our
    cart after AJAX requests.
==============================================================================*/

theme.CartSection = (function() {

  function CartSection(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);
    
    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    // If we are using a drawer, we initialise the drawer
    if (this.options['drawer']) {
      theme.CartDrawer = new theme.Drawers('CartDrawer', 'cart');
    }

    // Store itemCount
    var itemCount = this.options['itemCount'];

    // Store selectors
    this.selectors = {
      drawer: '#CartDrawer'
    };

    // Store loading flags
    this.status = {
      loaded: false,
      loading: false
    };

    var self = this;

    this.initEventListeners();

  }

  CartSection.prototype = $.extend({}, CartSection.prototype, {

    /**
     * #BOLD PRODUCT OPTIONS
     *
     * Our AJAX add to cart event listener is triggered by 
     * `theme.AjaxProduct.success`. 
     *
     * 1. We get the cart object using AJAX
     * 2. We then buildCart and pass in the original event, our cart object,
     *    a boolean to indicate we're using a Drawer, and the qty if we are
     *    changing qty/adding/removing an item
     */
    initEventListeners: function() {
      $('body').on('added.ajaxProduct', function(evt) {
        theme.ajaxCartUtilities.getCart().then(function(cart) { /* [1] */
          this.buildCart(evt, cart, true); /* [2] */
          
          

        }.bind(this));
      }.bind(this));


      /**
       * Quantity Selectors event listeners

       * 1. If we are using AJAX and in the drawer, we add event listeners for
       *    increasing/decreasing item quantity.
       * 2. If we are on a cart page and AJAX is enabled, then we want to
       *    refresh the cart page when a quantity is changed
       */
      if (this.options['type'] !== 'page') {
        $('[data-action="update-item-quantity"], [data-action="remove-item"]').on('click', this.updateItemQuantity.bind(this));
        $('.quantity-selector__current-quantity').on('change', this.updateItemQuantity.bind(this));
      } else {
        $('.quantity-selector__current-quantity').on('change', this._reloadPageWithQuantity.bind(this));
      }
    },


    /**
     * BUILDCART
     * We do not use a templating library like Handlebars to update our cart
     * directly in JS. Instead, we are storing our cart content on a hidden
     * template such as `templates/cart.drawer` or `templates/cart.ajax`.
     *
     * We the use the Shopify AJAX API to GET the HTML of these cart templates
     * to update our cart.
     *
     * This is a smart technique used in the Prestige theme. Whilst performance
     * could be improved slightly using JS – this solution allows for easier
     * app integration as it allows the Liquid to re-run all the time.
     *
     * @param {event} evt - The event that instigated buildCart
     * @param {object} cart - The cart object
     * @param {boolean} openDrawer - Not currently used. Plan was to use this to open the cart drawer
     * @param {string} qty - The relevant qty after a cart change e.g. remove, increase, decrease
     * @param {string} key – The relevant key of the product being changed
     */

    /**
     * #BOLD PRODUCT OPTIONS
     */

    buildCart: bldCart = function(evt, cart, openDrawer, qty, key) {
      // Bold:POv2.3 HYBRID
      if(typeof BOLD === 'object' && BOLD.options){
        BOLD.options.app.registerCartRenderFunction(bldCart);
      }
      // #BOLD PRODUCT OPTIONS
      if(window.BOLD && BOLD.common && BOLD.common.cartDoctor && typeof BOLD.common.cartDoctor.fix === 'function'){
          cart = BOLD.common.cartDoctor.fix(cart);
      }

      var self = this;

      // Set loading status to true
      this.loading(true);


      /**
       * As explained above, we're using AJAX to get the HTML of the relevant
       * cart template.
       *
       * If we have a successful AJAX operation such as add to cart, change, etc
       * 1. Store our returned HTML data as a variable
       * 2. Check if it's a drawer
       * 3. Run replaceContent with our new HTML
       * 4. Update our cart header count/icon by passing in our cart object
       * 5. Open the cart drawer
       *
       * 6. Else if we're on the cart page:
       * 7. Run replaceContent with our new HTML
       * 8. Update our cart header count/icon by passing in our cart object
       * 9. Reload the cart page with updated quantity. We need to pass in our
       *    qty and product key.
       */
      $.ajax('/cart?view=' + (this.options['drawer'] ? 'drawer' : 'ajax') + '&timestamp=' + Date.now(), {
          method: 'GET',
          dataType: 'html',
          success: function success(data) {
            var html = data; /* [1] */

            if (self.options['drawer']) { /* [2] */
              self._replaceContent(html); /* [3] */
              self._updateCartCount(cart); /* [4] */
              theme.CartDrawer.open(); /* [5] */
            } else {
              self._replaceContent(html); /* [6] */
              self._updateCartCount(cart); /* [7] */
              self._reloadPageWithQuantity(evt, cart, qty, key); /* [8] */
            }

            if (window.BOLD && BOLD.common && BOLD.common.eventEmitter &&
              typeof BOLD.common.eventEmitter.emit === 'function'){
            BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded', cart);
          }
            
            
          }
      });


      // #BOLD PRODUCT OPTIONS
  
    },



    /**
     * UPDATE CART COUNT
     * We pass in the cart object so we can easily get the updated item count
     * If we have a text count, we update the text.
     * If we're using a cart bubble, we add or remove a class.
     */

    _updateCartCount: function(cart) {
      
      // #BOLD PRODUCT OPTIONS
      if(window.BOLD && BOLD.common && BOLD.common.cartDoctor && typeof BOLD.common.cartDoctor.fix === 'function'){
        cart = BOLD.common.cartDoctor.fix(cart);
      }
      var count = cart.item_count;

      $('.header__cart-count').text(count);

      if (count > 0) {
        $('.header__cart-dot').addClass('header__cart-dot--is-visible');
      } else {
        $('.header__cart-dot').removeClass('header__cart-dot--is-visible');
      }
    },



    /**
     * REPLACE CONTENT
     * This takes the HTML data returned from our AJAX GET request to our hidden
     * cart templates.
     *
     * This code is similar to that used in the Prestige theme, using vanilla JS.
     * 
     * We construct a new `div` with our HTML content, and replace existing
     * content.
     */

    _replaceContent: function(html) {
      var tempElement = document.createElement('div');
      tempElement.innerHTML = html;

      var cartNodeParent = this.container.querySelector('.js-cart-content').parentNode;


      if (this.options['drawer']) {
        cartNodeParent.replaceChild(tempElement.querySelector('.js-cart-content'), this.container.querySelector('.js-cart-content'));
      }

      // We initialise our event listeners
      this.initEventListeners();
    },

    /**
     * LOADING
     * Adds variables and classes to indicate loading state.
     */

    loading: function(state) {
      this.status.loading = state;

      if (state) {
        $(this.selectors.container).addClass('is-loading');
      } else {
        $(this.selectors.container).removeClass('is-loading');
      }
    },



    /**
     * UPDATE ITEM QUANTITY
     * We pass in the event, so we can find the element that triggered this
     */

    updateItemQuantity: function(evt) {

      // Get element that triggered this event such as the increase or decrease
      // buttons
      var target = evt.currentTarget;

      // Store our key and qty variables
      var key = null;
      var qty = null;

      // Set key
      key = target.getAttribute('data-line-id');

      // If our target is the input element itself, we get the value
      // Else we get the data-quantity attribute of our increase/decrease btn
      if (target.tagName === 'INPUT') {
        qty = parseInt(Math.max(parseInt(target.value) || 1, 1));
      } else {
        qty = parseInt(target.getAttribute('data-quantity'));
      }

      // We run our theme.ajaxCartUtilities.changeItem utility and pass in the key and qty.
      // On success, we pass in the evt, cart object, qty, and key
      theme.ajaxCartUtilities.changeItem(key, qty)
        .then(function(cart) {
          this.updateSuccess(evt, cart, qty, key);
        }.bind(this))
        .catch(function(XMLHttpRequest) {
          this.updateError(XMLHttpRequest)
        }.bind(this))
        .always(function() {
          this.loading(false);
        }.bind(this));

      // We prevent default behaviour as our increase/decrease buttons are links
      evt.preventDefault();
    },


    // On success we run buildCart
    // #BOLD PRODUCT OPTIONS
    updateSuccess: function(evt, cart, qty, key) {
      //Bold: Ensure the cart's line items have been updated with their option information
      if(typeof(BOLD) === 'object' && BOLD.common && BOLD.common.cartDoctor && typeof(BOLD.common.cartDoctor.fix) === 'function' ){
        cart = BOLD.common.cartDoctor.fix(cart);
      }

      console.log('updateSuccess');
      this.buildCart(evt, cart, true, qty, key);

      if (window.BOLD && BOLD.common && BOLD.common.eventEmitter &&
          typeof BOLD.common.eventEmitter.emit === 'function'){
        BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded', cart);
      }

    },

    // On error, we add a console message
    updateError: function(XMLHttpRequest) {
      console.log('updateError');
      if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
        console.warn(XMLHttpRequest.responseJSON.description);
      }
    },


    /**
     * If we're using AJAX but on the cart page, we've set our qty selectors to
     * prevent default, meaning they won't refresh the page. So, we manually
     * refresh and add our updated qty/key
     */
    _reloadPageWithQuantity: function(evt, cart, qty, key) {

      var target = evt.target;

      /**
       * If using AJAX, we can get the qty and key as passed in by buildCart.
       * Else, we get the value and key of our target qty input element.
       */
      if (qty && key) {
        window.location.href = '/cart/change?quantity=' + parseInt(qty) + '&id=' + key;
      } else {
        var target = evt.currentTarget;
        var qty = target.getAttribute('data-quantity');
        var key = target.getAttribute('data-line-id');

        window.location.href = '/cart/change?quantity=' + parseInt(qty) + '&id=' + key;
      }
    },

    /**
     * Shopify Theme Editor events
     */

    forceReload: function() {
    },

    onSelect: function() {
    },

    onDeselect: function() {
    },

    onUnload: function() {
    }
  });

  return CartSection;
})();










/*==============================================================================
  #Collection
==============================================================================*/

theme.Collection = (function() {

  var selectors = {};

  var config = {};

  function Collection(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);

    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    // var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    this.settings = {};

    // Initialise section
    this.init();
  }


  Collection.prototype = $.extend({}, Collection.prototype, {

    init: function() {
      this.collectionSort();
    },

    collectionSort: function() {
      var $collectionSort = $('#CollectionSort');

      if (!$collectionSort.length) {
        return;
      }

      $collectionSort.on('change.collection', function() {
        location.href = '?sort_by=' + $(this).val();
      });
    }

  });

  return Collection;

})();










/*==============================================================================
  #SlideshowSection
==============================================================================*/

/**
 * We store our slideshows in an object
 */
theme.slideshows = {};

theme.SlideshowSection = (function() {

  function SlideshowSection(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);
    
    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get slideshow by ID
    var slideshow = this.slideshow = '#Slideshow--' + sectionId;

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    var $imageContainer = $(container).find('.slideshow');

    // Load image section allows for adding classes whilst loading so we can
    // animate
    if ($imageContainer.length) {
      theme.loadImageSection($imageContainer);
    }


    this.init();
  }


  SlideshowSection.prototype = $.extend({}, SlideshowSection.prototype, {
    init: function() {

      // Prevent slideshows from initializing on top of themselves
      this.onUnload();

      // Store slideshow as jQuery variable
      var $slideshow = $(this.slideshow);
      
      // Store options for Slick Slider
      var args = {
        autoplay: this.options['isAutoplay'],
        autoplaySpeed: this.options['autoplaySpeed'],
        arrows: this.options['showArrows'],
        dots: this.options['showDots'],
        prevArrow: $('.slideshow__arrow--prev'),
        nextArrow: $('.slideshow__arrow--next')
      };

      // Pass slideshow into the theme.slideshows object
      theme.slideshows[this.slideshow] = new theme.Slideshow(this.slideshow, args);

    },


    /**
     * Shopify Theme Editor events
     */

    forceReload: function() {
      this.init();
    },

    // On unload, destroy slideshow
    onUnload: function() {
      if (theme.slideshows[this.slideshow]) {
        theme.slideshows[this.slideshow].destroy();
        delete theme.slideshows[this.slideshow];
      }
    },

    // When working on the section, pause the slideshow if it has autoplay
    onSelect: function() {
      $(this.slideshow).slick('slickPause');
    },

    // When leaving the section, play the slideshow if it has autoplay
    onDeselect: function() {
      $(this.slideshow).slick('slickPlay');
    },

    // On block select, ignore cloned slides, go to selected slide, and pause
    // autoplay
    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      var $slide = $('.slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    // On block deselect, play slideshow if it has autoplay
    onBlockDeselect: function() {
      $(this.slideshow).slick('slickPlay');
    }
  });

  return SlideshowSection;
})();










/*==============================================================================
  #Instagram Section
==============================================================================*/

theme.Instagram = (function() {
  function Instagram(container) {
    var $container = this.$container = $(container);

    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get Instagram by ID
    var instagram = this.instagram = '#Section--' + sectionId;

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    var $target = $(instagram).find('.js-instagram-grid');

    if (!$target.length) {
      return;
    }

    var accessToken = this.options['accessToken'];
    var imageCount = this.options['imageCount'];
    var gridItemWidth = this.options['gridItemWidth'];

    var feed = this.feed = new Instafeed({
      get: 'user',
      userId: 'self',
      target: $target[0],
      accessToken: accessToken,
      sortBy: 'most-recent',
      limit: imageCount,
      resolution: 'standard_resolution',
      template: 
        '<div class="grid__item ' + gridItemWidth + ' instagram__item">' + 
          '<a href="{{link}}" rel="nofollow noopener" target="_blank" class="instagram__link">' + 
            '<div class="instagram__image  lazyload  image--fade-in" data-bgset="{{image}}" data-sizes="auto"  aria-label="Open on Instagram">' +
              '<div class="instagram__overlay">' + '<span class="instagram__like-count">' + 
                 '<svg viewBox="0 0 512 512" class="icon  icon--heart" aria-hidden="true" focusable="false" role="presentation">' + 
                    '<path d="M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z"></path>' + 
                  '</svg>' + '{{likes}} likes' + '</span>' + '<p class="instagram__caption">{{caption}}</p>' + '<time class="instagram__date">{{model.date}}</time>' +
                '</div>' + 
            '</div>' + 
          '</a>' + 
        '</div>',
        success: function success(data) {
          var dateTimeFormatter = new Intl.DateTimeFormat(window.theme.locale, { day: 'numeric', month: 'long', year: 'numeric' });

          data['data'].forEach(function (datum) {
            datum['date'] = dateTimeFormatter.format(new Date(parseInt(datum['created_time']) * 1000));
          });
        }
    });

    feed.run();
  }

  Instagram.prototype = $.extend({}, Instagram.prototype, {
    onUnload: function() {

    }
  });

  return Instagram;

})();










/*==============================================================================
  #Promo Bar Section
==============================================================================*/


theme.PromoBarSection = (function() {

  var slideCount = 0;

  function PromoBarSection(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);
    
    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    var wrapper = this.wrapper = '.promo-bar__wrapper';

    var slider = this.slider = '#PromoBar-' + sectionId;

    var $slider = $(slider);


    this.defaults = {
      accessibility: true,
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: this.options['autoplaySpeed'],
      touchThreshold: 20,
      slidesToShow: 3,
      slidesToScroll: 1,
      rows: 0
    };

    this.sliderActive = false;

    var mobileOptions = $.extend({}, this.defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });

    slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (slideCount < this.defaults.slidesToShow) {
      this.defaults.slidesToShow = slideCount;
      this.defaults.slidesToScroll = slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    if (theme.config.bpSmall) {
      this.init($slider, mobileOptions);
    } else {
      this.init($slider, this.defaults);
    }

    $('body').on('matchSmall', function() {
      this.init($slider, mobileOptions);
    }.bind(this));

    $('body').on('unmatchSmall', function() {
      this.init($slider, this.defaults);
    }.bind(this));

    // this.init($slider, this.defaults);

  }


  PromoBarSection.prototype = $.extend({}, PromoBarSection.prototype, {
    onUnload: function() {
      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $('.promo-bar__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    init: function(obj, args) {
      if (this.sliderActive) {
        obj.slick('unslick');
        this.sliderActive = false;
      }

      obj.slick(args);
      this.sliderActive = true;
    },

    destroy: function(obj) {
      if (this.sliderActive) {
        obj.slick('unslick');
        this.sliderActive = false;
      }
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return PromoBarSection;
})();










/*==============================================================================
  #Testimonials Section
==============================================================================*/

theme.TestimonialsSection = (function() {

  var slideCount = 0;

  function TestimonialsSection(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);
    
    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    var wrapper = this.wrapper = '.testimonials__wrapper';

    var slider = this.slider = '#Testimonials-' + sectionId;

    var $slider = $(slider);


    this.defaults = {
      accessibility: true,
      arrows: false,
      dots: true,
      autoplay: this.options['isAutoplay'],
      autoplaySpeed: this.options['autoplaySpeed'],
      touchThreshold: 20,
      slidesToShow: 1,
      slidesToScroll: 1,
      rows: 0
    };

    this.sliderActive = false;

    slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (slideCount < this.defaults.slidesToShow) {
      this.defaults.slidesToShow = slideCount;
      this.defaults.slidesToScroll = slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    this.init($slider, this.defaults);

  }


  TestimonialsSection.prototype = $.extend({}, TestimonialsSection.prototype, {
    onUnload: function() {
      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $('.testimonials__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    init: function(obj, args) {
      if (this.sliderActive) {
        obj.slick('unslick');
        this.sliderActive = false;
      }

      obj.slick(args);
      this.sliderActive = true;
    },

    destroy: function(obj) {
      if (this.sliderActive) {
        obj.slick('unslick');
        this.sliderActive = false;
      }
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return TestimonialsSection;
})();










/*==============================================================================
  #Featured Video Section
==============================================================================*/

theme.FeaturedVideoSection = (function() {

  function FeaturedVideoSection(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);
    
    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    var isAutoplay = options['isAutoplay'];
    var $video = $container.find('.js-video-iframe');
    var videoSrc = $video.data('src');
    var $videoPoster = $container.find('.js-video-poster');
    var videoIsPlaying = false;

    // If is autoplay
      // If NOT isTouch
        // On elementvisible, play the video
      // else
        // Play on click of videoposter
    // else
      // Play on click of videoposter

    if (isAutoplay) {
      if (!theme.config.isTouch) {
        $(window).on('scroll.video', $.throttle(150, function(evt) {
          if (!videoIsPlaying) {
            if (theme.isElementVisible($video)) {
              videoIsPlaying = true;

              $video.attr('src', videoSrc);
              $videoPoster.addClass('video-poster--hidden');
            }
          }
        }));

      } else {
        $videoPoster.on('click', function(evt) {
          videoIsPlaying = true;

          $video.attr('src', videoSrc);
          $videoPoster.addClass('video-poster--hidden');
        });
      }
    } else {
      $videoPoster.on('click', function(evt) {
        videoIsPlaying = true;

        $video.attr('src', videoSrc);
        $videoPoster.addClass('video-poster--hidden');
      });
    }

  }

  return FeaturedVideoSection;
})();




















/*==============================================================================
  #initEventModals
==============================================================================*/

theme.initEventModals = function(reinit) {
  var ids = [];
  var $buttons = $('.js-event-btn');

  $buttons.each(function() {
    var id = $(this).data('article-id');
    var modalId = 'EventModal-' + id;
    var name = 'event-' + id;

    // If another identical modal exists, remove duplicates
    if (ids.indexOf(id) > -1) {
      $('.modal--event[data-article-id="'+ id +'"]').each(function(i) {
        if (i > 0) {
          $(this).remove();
        }
      });
      return;
    }

    new theme.Modals(modalId, name);
    ids.push(id);
  });
};










/*==============================================================================
  #Newsletter AJAX Mailchimp
==============================================================================*/

theme.ajaxNewsletterForm = function() {

  // Set variables for footer and popup classes
  var $newsletterFooter = $('.js-newsletter-footer');
  var $newsletterFooterResponse = $('.js-newsletter-footer-response');

  var $newsletterSection = $('.js-newsletter-section-form');
  var $newsletterSectionResponse = $('.js-newsletter-section-response');


  // Our submit event listener for a specific form
  function ajaxMailChimpForm($form, $responseElement) {
    $form.submit(function(evt){
      evt.preventDefault();
      submitForm($form, $responseElement);
    });
  }


  // Submit form event handler
  function submitForm($form, $responseElement) {
    $.ajax({
      type: "GET",
      url: $form.attr("action"),
      data: $form.serialize(),
      cache: false,
      dataType: "jsonp",
      jsonp: "c", // trigger MailChimp to return a JSONP response
      contentType: "application/json; charset=utf-8",

      error: function(error) {
        // According to jquery docs, this is never called for cross-domain JSONP requests
        alert("Could not connect to the server. Please try again later.");
      },

      success: function(data) {
        if (data.result != "success") {

          if (data.msg && data.msg.indexOf("already subscribed") >= 0) {
            $responseElement.removeClass('alert--success').addClass('alert--error');
            $responseElement.html("You are already subscribed.");

          } else {
            $responseElement.removeClass('alert--success').addClass('alert--error');
            $responseElement.html(data.msg);
          }

        } else {
          $responseElement.removeClass('alert--error').addClass('alert--success');
          $responseElement.html("Thanks for subscribing!");
        }
      }
    });
  }

  // Run the code for each newsletter form on your page
  ajaxMailChimpForm($newsletterFooter, $newsletterFooterResponse);
  ajaxMailChimpForm($newsletterSection, $newsletterSectionResponse);
}










/*==============================================================================
  #theme.isElementVisible
  - Used for autoplay videos
==============================================================================*/

theme.isElementVisible = function($el, threshold) {
  var rect = $el[0].getBoundingClientRect();
  var windowHeight = window.innerHeight || document.documentElement.clientHeight;
  threshold = threshold ? threshold : 0;

  return (
    rect.bottom >= 0 &&
    rect.right >= 0 &&
    rect.top <= (windowHeight + threshold) &&
    rect.left <= (window.innerWidth || document.documentElement.clientWidth)
  );
};










/*==============================================================================
  # Theme Load Image Section
  - Allows for adding classes whilst loading so we can animate
==============================================================================*/

theme.loadImageSection = function($container) {
  // Wait until images inside container have lazyloaded class
  function setAsLoaded() {
    $container.removeClass('loading loading--delayed').addClass('loaded');
  }

  function checkForLazyloadedImage() {
    return $container.find('.lazyloaded').length;
  }

  // If it has SVGs it's in the onboarding state so set as loaded
  if ($container.find('svg').length) {
    setAsLoaded();
    return;
  };

  if (checkForLazyloadedImage() > 0) {
    setAsLoaded();
    return;
  }

  var interval = setInterval(function() {
    if (checkForLazyloadedImage() > 0) {
      clearInterval(interval);
      setAsLoaded();
    }
  }, 80);
};










/*==============================================================================
  #OTHER
==============================================================================*/

/*==============================================================================
  #Config
==============================================================================*/

/**
 * There is no accurate way of detecting a touch device using JS. Ideally, you
 * would wait for a users first iteraction and determine if it's a touch or
 * mouse move:
 * https://blogs.perficientdigital.com/2017/11/21/detecting-the-use-of-a-touch-screen/
 *
 * `ontouchstart` is used by Modernizer:
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/touchevents.js#L40
 * 
 * `DocumentTouch`: very old and obsolete API since Gecko 25 (Firefox 25). Also
 * used by Modernizr.
 * https://developer.mozilla.org/en-US/docs/Web/API/DocumentTouch
 *
 * `maxTouchPoints`: returns number of touch contact points connected to the
 * device. Might not be best idea? Supported by Chrome Android, but not iOS.
 * https://developer.mozilla.org/en-US/docs/Web/API/Navigator/maxTouchPoints
 *
 * `msMaxTouchPoints`: Only works for IE10. Future IEs removed this and used
 * standard `maxTouchPoints`:
 * https://technet.microsoft.com/en-us/windows/hh772144(v=vs.60)
 *
 * `matchMedia`: Similar to Prestige theme. matchMedia support is here:
 * https://developer.mozilla.org/en-US/docs/Web/API/Window/matchMedia
 *
 * `moz-touch-events` no longer available to web content since Firefox 58:
 * https://developer.mozilla.org/en-US/docs/Web/CSS/@media/-moz-touch-enabled
 *
 * `isIpad` uses the JS test method to check if the userAgent matches the
 * string of `ipad`. Read negative things about userAgent detection but mainly
 * from long time ago. This iPad setting was used on Impulse theme to add a
 * 'js-ipad' class to body and change some background attachments to initial.
 * We won't need it.
 */


theme.config = {
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false || window.matchMedia('(-moz-touch-enabled: 1), (hover: none)').matches,
  mq: 'initial',
  bpSmall: false
};


theme.mq = {
  small: 'screen and (max-width: 767px)',
  medium: 'screen and (min-width: 768px) and (max-width: 960px)',
  large: 'screen and (min-width: 961px) and (max-width: 1239px)',
  desk: 'screen and (min-width: 1240px)'
};




















/*==============================================================================
  #init
==============================================================================*/

theme.init = function() {
  enquire.register(theme.mq.small, {
    match: function() {
      theme.config.mq = 'small';
      theme.config.bpSmall = true;
      $('body').trigger('matchSmall');
    },
    unmatch: function() {
      theme.config.bpSmall = false;
      $('body').trigger('unmatchSmall');
    }
  });

  enquire.register(theme.mq.medium, {
    match: function() {
      theme.config.mq = 'medium';
      $('body').trigger('matchMedium');
    }
  });



  /**
   * Tab Handling
   * We use CSS to remove focus outlines on a lot of elements for aesthetic
   * reasons.
   * In order to maintain accessibility, we can recognise if a user is tabbing
   * and add an `is-tabbing` class which will allow us to add focus outlines in 
   * the CSS.
   */

  $(document.documentElement).on('keyup.tab', function(evt) {
    if (evt.keyCode === 9) {
      $(document.documentElement).addClass('is-tabbing');
      $(document.documentElement).off('keyup.tab');
    }
  });


  theme.Collapsibles.init();
  theme.Tabs.init();
  theme.ajaxNewsletterForm();
  theme.initEventModals();

  var searchModal = new theme.Modals('SearchModal', 'search');

  // AOS Init
  AOS.init({
    startEvent: 'load',
    easing: 'ease-out-quad',
    once: true,
    offset: 100
  });

}




















/*==============================================================================
  #TEMPLATES
==============================================================================*/

/*==============================================================================
  #Customer Addresses
  - Largely based off Slate
  - Handles customer addresses functionality
==============================================================================*/

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');
  var $addressForms = $('.js-address-form');

  // If no address forms exist, we don't run the code
  if (!$newAddressForm.length || !$addressForms.length) {
    return;
  }

  // Certain countries require province selection such as Spain, Canada, UAE
  // We use Shopify.CountryProvinceSelector to show/hide the province selector
  if (Shopify) {
    $('.js-address-country').each(function() {
      var $container = $(this);
      var countryId = $container.data('country-id');
      var provinceId = $container.data('province-id');
      var provinceContainerId = $container.data('province-container-id');

      new Shopify.CountryProvinceSelector(
        countryId,
        provinceId,
        {
          hideElement: provinceContainerId
        }
      );
    });
  }


  // Toggle new address form
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  // Toggle edit address form
  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  // Delete address event handler
  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();










/*==============================================================================
  #Customer Login
  - Largely based off Slate
  - Handles login / recover password form
==============================================================================*/

theme.customerLogin = (function() {
  var config = {
    recoverPasswordToggle: '[data-action="toggle-recover-form"]',
    recoverPasswordForm: '#RecoverPasswordForm'
  };

  // Check recover password form exist
  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordToggle).on('click', onShowHidePasswordForm);
  // $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();











/*==============================================================================
  #Shopify Shipping Calculator
==============================================================================*/

if (Shopify.Cart) {
  Shopify.Cart.ShippingCalculator.show( {
    submitButton: theme.strings.shippingCalcSubmitButton,
    submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
    customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
    moneyFormat: theme.strings.shippingCalcMoneyFormat
  });
}










/*==============================================================================
  #DOC READY
==============================================================================*/

$(document).ready(function() {

  theme.init();

  var sections = new theme.Sections();
  sections.register('header-section', theme.HeaderSection);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('drawer-menu-section', theme.DrawerMenuSection);
  sections.register('cart-section', theme.CartSection);
  sections.register('product', theme.Product);
  sections.register('collection-template-section', theme.Collection);
  sections.register('instagram-section', theme.Instagram);
  sections.register('promo-bar-section', theme.PromoBarSection);
  sections.register('testimonials-section', theme.TestimonialsSection);
  sections.register('featured-video-section', theme.FeaturedVideoSection);


  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });


  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });


  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

});